import { useId, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { useOverlay } from './use-overlay';
import styles from './Modal.module.css';

export type ModalProps = {
  open: boolean;
  onClose: () => void;
  /** CEVRILMIS baslik. */
  title?: ReactNode;
  children: ReactNode;
  /** Alt eylem satiri (Vazgec / Onayla). */
  footer?: ReactNode;
  width?: 'sm' | 'md' | 'lg';
  /** Perdeye tiklayinca kapansin mi. Veri kaybettirecek formlarda kapatilir. */
  dismissOnScrim?: boolean;
  className?: string;
};

export function Modal({
  open,
  onClose,
  title,
  children,
  footer,
  width = 'md',
  dismissOnScrim = true,
  className,
}: ModalProps) {
  const titleId = useId();
  useOverlay(open, onClose);

  if (!open) return null;

  return createPortal(
    <div
      className={styles.scrim}
      onMouseDown={(event) => {
        // Sadece perdenin KENDISINE basildiginda kapan; icerikte baslayan bir
        // surukleme perdede bitince yanlislikla kapanmasin.
        if (dismissOnScrim && event.target === event.currentTarget) onClose();
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? titleId : undefined}
        className={[styles.panel, styles[width], className].filter(Boolean).join(' ')}
      >
        {title ? (
          <header className={styles.header}>
            <h2 className={styles.title} id={titleId}>
              {title}
            </h2>
            <button type="button" className={styles.close} onClick={onClose} aria-label="Kapat">
              <X size={18} aria-hidden="true" />
            </button>
          </header>
        ) : null}
        <div className={styles.body}>{children}</div>
        {footer ? <footer className={styles.footer}>{footer}</footer> : null}
      </div>
    </div>,
    document.body,
  );
}
